
const Loader = (props) => {
    return (
        <>
            {props.size === 'small' && <div className="spinner-border spinner-border-sm text-success" role="status"/>}
            {props.size === 'medium' && <div className="spinner-border avatar-md text-success" role="status"/>}
            {props.size === 'large' && <div className="spinner-border avatar-lg text-success" role="status"/>}
            {props.size === 'default' && <div className="spinner-border text-success" role="status"/>}
        </>
    )
}


export default Loader;